import conversationCache from './conversationCache';
import ConversationItemParts from './schema/ConversationItemParts';
import ConversationReadingPaneNode from './schema/ConversationReadingPaneNode';
import deleteConversationItemParts from '../actions/deleteConversationItemParts';
import Folder from './schema/Folder';
import MailStore from './schema/MailStore';
import Module from 'mini-module-switcher/lib/schema/Module';
import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';

const mailStoreData: MailStore = {
    attachments: new ObservableMap({}),
    conversationNodes: new ObservableMap<string, ConversationReadingPaneNode>({}),
    conversations: new ObservableMap<string, ConversationItemParts>({}),
    folders: {
        folderTable: new ObservableMap<string, Folder>({}),
        rootFolder: null,
        selectedFolderId: null,
        selectedFocusedViewFilter: null,
    },
    items: new ObservableMap({}),
    mailModule: {
        selectedId: null,
        selectedSubject: null,
        selectedIndex: -1,
        selectedModule: Module.Mail,
        selectedSubRoute: null,
        selectedSubRouteOption: null,
        triageActionSelectedId: null,
    },
    isReadOnly: null,
    todayDate: null, // Make easy to have the UI update on date changes, just by observing this value.
    showAd: true,
};

export const getStore = createStore<MailStore>('mail', mailStoreData);
const store = getStore();

// Cache eviction deletes conversation from mailStore using deleteConversationItemParts
conversationCache.initialize(store.conversations, key => {
    deleteConversationItemParts(key);
});

export default store;
